module.exports = __webpack_public_path__ + "static/img/Six of Wands.0ede4f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Six of Wands.jpg
// module id = 1302
// module chunks = 0